import { IconName } from '@/components/atoms/Icon';
import { FitType, LayoutType, SizeType } from '@/domains/asset';

export interface LayoutPopupOption {
  label: string;
  icon: IconName;
}

export const ASPECT_RATIO_OPTIONS: Record<SizeType, LayoutPopupOption & { helpText?: string }> = {
  LANDSCAPE: {
    label: '16:9',
    icon: 'IconCropLandscape',
    helpText: 'LinkedIn, Youtube'
  },
  SQUARE: {
    label: '1:1',
    icon: 'IconCrop11',
    helpText: 'Carousel, Twitter'
  },
  PORTRAIT: {
    label: '9:16',
    icon: 'IconCropPortrait',
    helpText: 'Shorts, Reels, Stories'
  }
};

export const MAGIC_LAYOUT_OPTIONS: Record<
  Extract<LayoutType, 'SPEAKER' | 'GRID' | 'FOCUS' | 'PIP'>,
  LayoutPopupOption
> = {
  SPEAKER: {
    label: 'Active Speaker',
    icon: 'IconUserScan'
  },
  GRID: {
    label: 'Speaker Grid',
    icon: 'IconLayoutGrid'
  },
  FOCUS: {
    label: 'Focus',
    icon: 'IconLayoutSidebarRight'
  },
  PIP: {
    label: 'Picture in Picture',
    icon: 'IconPictureInPicture' // or suitable icon
  }
};

export const FIT_OPTIONS: Record<FitType, LayoutPopupOption> = {
  FILL: {
    label: 'Fill',
    icon: 'IconAspectRatio'
  },
  FIT: {
    label: 'Fit',
    icon: 'IconSection'
  }
};
